import { Component, Input, OnChanges, Output, EventEmitter } from '@angular/core';
import { Step } from '../../../../shared/models/cerebrum-core';
import { nodeEmitter } from '../../services/flowBuilder/utils/locaction-calculator-interface';
import { FlowWebSocketsService } from '../../services/flowBuilder/flow-web-sockets.service';
import { DeleteStepData } from '../../services/flowBuilder/models';
import { SharedService } from '../../../../core/services/store/shared-store/shared-storage.service';

@Component({
  selector: 'app-edit-node',
  templateUrl: './edit-node.component.html',
  styleUrls: ['./edit-node.component.scss'],
})
export class EditNodeComponent implements OnChanges {
  constructor(public flowWebSocket: FlowWebSocketsService, public sharedService: SharedService) {}

  @Input('stepInfo') stepInfo: nodeEmitter;
  @Input() isRecycleBin: nodeEmitter;
  @Input() currentFlowSteps: string[];
  @Output() saveNode = new EventEmitter<Object>();
  @Output() deleteNode = new EventEmitter<DeleteStepData>();

  currentSelectedStep: Step;
  nodeType: string;
  nodeTitle: string;

  ngOnChanges(): void {
    this.nodeType = this.stepInfo.nodeType;
    this.currentSelectedStep = this.stepInfo.step as Step;
    this.nodeTitle = this.stepInfo.id;
  }

  saveNodeClicked(event: Object) {
    this.saveNode.emit(event);
  }

  deleteNodeClicked(stepId: string) {
    const deleteStep: DeleteStepData = {
      stepId: stepId,
      parentId: this.stepInfo.parentId,
    };
    this.deleteNode.emit(deleteStep);
  }
}
